/**
 * Classe permettant de palier à la limite JS des décimaux
 * */
export class IsiBigFloat {

    _partieEntiere;
    _partieDecimal;
    _partieSign;
    _isNumber;
    _param;
    _value;

    constructor(element) {
        this._partieEntiere = null;
        this._partieDecimal = null;
        this._partieSign = null;
        this._isNumber = false;
        this._param = element;
        this._value = null;
        this.initBigFloat();
    }

    initBigFloat() {
        var expRegBigFloat = new RegExp("^(([+|-])?([0-9]+)?([.|,]([0-9]+))?)$");
        var bigFloat;
        bigFloat = this._param;
        bigFloat = bigFloat.toString();
        var re = new RegExp(Sys.CultureInfo.CurrentCulture.numberFormat.NumberGroupSeparator, "gi");

        bigFloat = bigFloat.replace(re, "");
        bigFloat = bigFloat.replace(/\s/gi, "");
        bigFloat = bigFloat.replace(",", ".");

        // On test si le format est bien celui de l'expression régulière
        this._isNumber = expRegBigFloat.test(bigFloat);
        //ABON vu avec CLEM si c'est une chaine vide il n'y a pas d'informations a reprendre.
        if (bigFloat == "") {
            this._partieSign = "";
            this._partieDecimal = "";
            this._partieEntiere = "";
            this._value = "";
            this._isNumber = false;
        } else {
            if (this._isNumber) {
                var result;
                result = expRegBigFloat.exec(bigFloat);
                // IsiBigFloat est une chaine de caractères composees d'un separateur "." d'une partie entiere et d'un partie décimale
                //recuperation du signe
                if (result[2] == "+" || result[2] == undefined) {
                    this._partieSign = "";
                } else {
                    this._partieSign = result[2];
                }
                //recuperation de la partie entiere
                if (result[3]) {
                    this._partieEntiere = result[3];
                } else {
                    this._partieEntiere = "0";
                }
                //recuperation de la partie decimale
                if (result[4]) {
                    this._partieDecimal = result[4];
                } else {
                    this._partieDecimal = "";
                }
                //reconstruction / merdier?
                this._value = this._partieSign + this._partieEntiere + this._partieDecimal;
                //this.convBigNumDecimal(nbDecimal)
            }
        }
    }

    getPartieEntiere() {
        return this._partieEntiere;
    }

    getPartieDecimal() {
        return this._partieDecimal;
    }

    getPartieSign() {
        return this._partieSign;
    }

    getIsNumber() {
        return this._isNumber;
    }

    getIsInteger() {
        if (this._isNumber && this._partieDecimal === "") {
            return true;
        } else {
            return false;
        }
    }

    getIsFloat() {
        if (this._isNumber && this._partieDecimal !== "") {
            return true;
        } else {
            return false;
        }
    }

    getValue() {
        return this._value;
    }

    toString() {
        return (this._partieEntiere + this._partieDecimal);
    }

    /**
     * Affecte au resultat le format monetaire complete de zeros jusqu'au nombre de chiffres demandes apres la virgule
     * @param iNbFlottants
     */
    convBigNumDecimal(iNbFlottants) {
        var sResult;
        var decimal;
        var formatedVal = window.isiGetNumber(this._partieEntiere).localeFormat("N" + iNbFlottants);
        formatedVal = formatedVal.substring(0, formatedVal.length - iNbFlottants).replace(" ", "");
        decimal = this._partieDecimal;
        //On enleve le . ou la ,
        decimal = decimal.substring(1);
        if (decimal.length > iNbFlottants) {
            // LBRI - 2013.02.22 - [DYSF:] : la fonction substring retourne une valeur, il faut la prendre en compte
            // SDEN - 14/02/2017 - PB0016530 : on fait un round pour le calcul monétaire
            var arrondi;
            arrondi = parseFloat("0." + decimal).toFixed(iNbFlottants);
            decimal = arrondi.substring(2);

            //Si la partie entière de la partie décimale arrondie est 1
            // On l'ajoute sinon par exemple 15.9999 devenait 15.000 au lieu de 16.000
            if (parseInt(arrondi.substring(0, 1)) === 1) {
                this._partieEntiere = (window.isiGetNumber(this._partieEntiere) + 1).localeFormat("N");
                formatedVal = window.isiGetNumber(this._partieEntiere).localeFormat("N" + iNbFlottants);
                formatedVal = formatedVal.substring(0, formatedVal.length - iNbFlottants).replace(" ", "");
            }
        } else {
            while (decimal.length < iNbFlottants) {
                decimal += "0";
            }
        }
        if (iNbFlottants > 0) {
            sResult = this._partieSign + formatedVal + decimal;
        } else {
            sResult = this._partieSign + formatedVal;
        }

        return sResult
    }

    /**
     * Formate une valeur jusqu'au nombre de décimales demandé,
     * sans effectuer d'arrondi.
     * @param iNbFlottants Nombre de chiffres après la virgule.
     * @returns La valeur formatée sous forme de chaîne de caractères.
     */
    convBigNumDecimalWithoutRound(iNbFlottants: number): string {
        let formatedVal: string = globalThis.isiGetNumber(this._partieEntiere).localeFormat(`N${iNbFlottants}`);
        formatedVal = formatedVal.substring(0, formatedVal.length - iNbFlottants).replace(" ", "");

        // On extrait la partie décimale (sans le séparateur)
        let decimal: string = this._partieDecimal.substring(1);

        // Troncature si nécessaire (sans arrondi)
        if (decimal.length > iNbFlottants) {
            decimal = decimal.substring(0, iNbFlottants);
        } else if (decimal.length < iNbFlottants) {
            // Ajout de zéros à droite si pas assez de décimales
            decimal = decimal.padEnd(iNbFlottants, '0');
        }

        // Construction du résultat final
        const sResult: string = iNbFlottants > 0
            ? `${this._partieSign}${formatedVal}${decimal}`
            : `${this._partieSign}${formatedVal}`;

        return sResult;
    }


    estEgal(sBigFloat) {

        var iDecimale1 = "0";
        var iDecimale2 = "0";

        // Si une partie decimale n'est pas renseignee, alors on l'initialise a zero.
        if (sBigFloat.partieDecimal) {
            iDecimale1 = sBigFloat.partieDecimal;
        }

        if (this._partieDecimal) {
            iDecimale2 = this._partieDecimal;
        }


        if (sBigFloat.partieSign == this._partieSign &&
            sBigFloat.partieEntiere == this._partieEntiere &&
            parseFloat(iDecimale1) == parseFloat(iDecimale2)) {
            return true;
        } else {
            return false;
        }
    }

    estSuperieur(mBigFloat) {
        var bResult = false;
        if (this._partieSign == mBigFloat.partieSign) {
            if (parseFloat(this._partieEntiere) > parseFloat(mBigFloat.partieEntiere)) {
                bResult = true;
            } else if (this._partieEntiere == mBigFloat.partieEntiere) {
                if (mBigFloat.partieDecimal != "" && this._partieDecimal != "") {
                    if (parseFloat(this._partieDecimal) > parseFloat(mBigFloat.partieDecimal)) {
                        bResult = true;
                    }
                } else {
                    if (this._partieDecimal.length > mBigFloat.partieDecimal.length) {
                        bResult = true;
                    }
                }
            }

            if (this._partieSign == "-") {
                bResult = !bResult;
            }
        } else if (this._partieSign == "" && mBigFloat.partieSign == "-") {
            bResult = true;
        }
        return bResult;
    }


}
